 import React from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaWhatsapp,
  FaInstagram,
  FaTiktok,
  FaHome,
  FaInfoCircle,
  FaProjectDiagram,
  FaBlog,
  FaEnvelope,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h2>EcoVibe</h2>
          <p>
            EcoVibe is dedicated to raising environmental awareness and
            promoting sustainable living. Join us in making the planet greener.
          </p>
        </div>
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <FaHome className="link-icon" />
              <Link to="/">Home</Link>
            </li>
            <li>
              <FaInfoCircle className="link-icon" />
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <FaProjectDiagram className="link-icon" />
              <Link to="/campaign">Campaign</Link>
            </li>
            <li>
              <FaBlog className="link-icon" />
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <FaEnvelope className="link-icon" />
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>
        </div>
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p>Email: info@ecovibe.com</p>
          <p>Phone: +92 300 1234567</p>
          <div className="footer-social">
            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.whatsapp.com/" target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/" target="_blank" rel="noreferrer" aria-label="TikTok">
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          2026 EcoVibe. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;